import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import AppRoutes from '../routes/appRoutes'

const useOldUser = () => {
    const { push } = useHistory()
    const oldInfo = useSelector(
        state => state?.AuthSlice?.user?.dashboard?.openEstimateCount,
    )
    const userRole = useSelector(state => state?.AuthSlice?.role)

    const authenticated = useSelector(state => state?.AuthSlice?.authenticated)

    const isAdmin = authenticated && userRole === 'admin'
    const isSalesperson = authenticated && userRole === 'salesperson'
    const isElevatedUser = isAdmin || isSalesperson

    const chackOldUserInformation = () => {
        if (authenticated && !isElevatedUser && oldInfo == null) {
            push(AppRoutes.logout())
            // change alert
        }
    }

    return {
        chackOldUserInformation,
    }
}

export default useOldUser
